import { logUserDataResponseError, processUpdateResponse } from './processResponse';
import { makePostRequest } from 'owa-ows-gateway';
import {
    CreateUserDataItemRequest,
    UserDataStoreRequestStatus,
} from '../data/schema/UserDataStoreSchema';

const UPDATE_USER_DATA_ITEM_NAME = 'UpdateUserDataItem';
const USER_DATA_STORE_CREATE_INFO_BASE: string = 'ows/v1.0/UserDataStore/item';
const USER_INFO_CATEGORY = 'UserInfo';

/**
 * Create and insert the UserDataStore for the current user with the provided key-value pair.
 * We currently only support 'UserInfo' category, might enable the category selection later.
 * The function will return the UserDataStoreRequestStatus for error handling purpose.
 */
export default async function createUserDataInfoService(
    key: string,
    value: string,
    category?: string
): Promise<UserDataStoreRequestStatus> {
    const request: CreateUserDataItemRequest = {
        category: category ? category : USER_INFO_CATEGORY, // By default using 'UserInfo' category.
        key: key,
        value: value,
    };
    try {
        const response = await makePostRequest(
            USER_DATA_STORE_CREATE_INFO_BASE,
            request,
            undefined /* correlationId */,
            true /* returnFullResponse */,
            undefined /* customHeaders */,
            undefined /* throwServiceError */,
            undefined /* sendPayloadAsBody */,
            undefined /* includeCredentials */,
            'createUserDataInfo' /* actionName */
        );
        return processUpdateResponse(response, UPDATE_USER_DATA_ITEM_NAME);
    } catch (error) {
        logUserDataResponseError(UPDATE_USER_DATA_ITEM_NAME, error?.message);
        return Promise.resolve(UserDataStoreRequestStatus.UNEXPECTED_ERROR);
    }
}
